import { createBrowserHistory } from 'history';

import i18n from '@i18n';
import PopupNg from '@/ui/PopupNg';
import { trackDwhPageViewEvent } from 'nike-ui/src/components/dwh-tracking/api';

const history = createBrowserHistory({
    getUserConfirmation(message, callback) {
        // Show some custom dialog to the user and call
        // callback(true) to continue the transiton, or
        // callback(false) to abort it.
        PopupNg.dispatcher.open('dialog/message', {
            titleText: i18n('registration.leave.title'),
            bodyText: i18n('registration.leave.text'),
            confirmText: i18n('registration.leave.action.stay'),
            cancelText: i18n('registration.leave.action.leave'),
            onCancel: () => callback(true),
            onConfirm: () => callback(false)
        });
    }
});

history.listen(function() {
    trackDwhPageViewEvent();
});

export default history;
